require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projecten-ontdekkingsreis-naar-nieuw-zeeland.json") })
        }
      }, "path---projecten-ontdekkingsreis-naar-nieuw-zeeland");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projecten-ontdekkingsreis-naar-nieuw-zeeland!./.cache/json/projecten-ontdekkingsreis-naar-nieuw-zeeland.json
// module id = 434
// module chunks = 231608221292675